import React from 'react'
import PropTypes from 'prop-types'

class InputSingle extends React.Component {
  render() {
    const props = this.props
    return (
      <div className='form-field single-field'>
        <input
          type={props.type}
          autoComplete={'off'}
          className={'form-input'}
          id={props.id}
          defaultValue={props.defaultValue}
          value={props.value}
          onSubmit={props.onBlur}
          onChange={props.onChange}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
          placeholder={props.placeholder}
          disabled={props.disabled ? 'disabled' : ''}
        />
      </div>
    )
  }
}

InputSingle.propTypes = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string
}

InputSingle.defaultProps = {
  placeholder: 'search ..'
}

export default InputSingle



// WEBPACK FOOTER //
// ./src/ui/forms/input-single.js